import urlcat from 'urlcat';
import type { AxiosRequestConfig } from 'axios';
import type { HttpProgressUpdate, ModuleConstructorProps, Skin as SkinModel } from '../Types';
import { BaseEntityModuleFuncs } from './BaseEntityModuleFuncs';

const Skin = ({ endpoints, httpClient, baseUrl }: ModuleConstructorProps) => {
    const uploadLogo =
        (
            endpoint:
                | 'uploadLargeLogo'
                | 'uploadSmallLogo'
                | 'uploadLargeDarkLogo'
                | 'uploadSmallDarkLogo',
        ) =>
        (
            {
                skinId,
                formData,
                onProgress,
            }: {
                skinId: number;
                formData;
                onProgress?: HttpProgressUpdate;
            },
            config?: AxiosRequestConfig,
        ) =>
            httpClient.postFile<{ data: SkinModel }>(
                urlcat(endpoints.Entities.Skin[endpoint], { id: skinId }),
                formData,
                onProgress,
                {},
                config,
            );

    return {
        ...BaseEntityModuleFuncs<SkinModel>({ endpoints, httpClient, baseUrl }, 'Skin'),
        uploadLargeLogo: uploadLogo('uploadLargeLogo'),
        uploadSmallLogo: uploadLogo('uploadSmallLogo'),
        uploadLargeDarkLogo: uploadLogo('uploadLargeDarkLogo'),
        uploadSmallDarkLogo: uploadLogo('uploadSmallDarkLogo'),
        attach: (
            {
                skinId,
                users,
                agencies,
                buyers,
                clients,
                owners,
            }: {
                skinId: number;
                users?: number[];
                agencies?: number[];
                buyers?: number[];
                clients?: number[];
                owners?: number[];
            },
            config?: AxiosRequestConfig,
        ) => {
            const data = {
                ...(users != null && { users }),
                ...(agencies != null && { agencies }),
                ...(buyers != null && { buyers }),
                ...(clients != null && { clients }),
                ...(owners != null && { owners }),
            };

            return httpClient.post<{ data: SkinModel }>(
                urlcat(endpoints.Entities.Skin.attach, {
                    id: skinId,
                }),
                data,
                config,
            );
        },
    };
};

export default Skin;
